import React from 'react';

const TimelineMedicationRequestOnlyIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="9.125" cy="9" r="8.5" fill="#8590C1" />
    </svg>
  );
};

export default TimelineMedicationRequestOnlyIcon;
